export const perPageOptions = [12, 24, 60];
